import React from 'react';

const Contact = () => {
  return (
    <div className="contact-page">
      <div className="hero-section">
        <h1>Contact Us</h1>
        <p className="subtitle">Get in touch with our support team</p>
      </div>

      <div className="content-section">
        <div className="contact-grid">
          <div className="contact-info">
            <div className="info-card">
              <h2>Contact Information</h2>
              <div className="info-items">
                <div className="info-item">
                  <div className="icon">📞</div>
                  <div className="details">
                    <h3>Phone</h3>
                    <p>(800) 123-4567</p>
                    <span className="note">Available 24/7 for emergency support</span>
                  </div>
                </div>
                <div className="info-item">
                  <div className="icon">✉️</div>
                  <div className="details">
                    <h3>Email</h3>
                    <p>support@hotsiderepairs.com</p>
                    <span className="note">We'll respond within 24 hours</span>
                  </div>
                </div>
                <div className="info-item">
                  <div className="icon">📍</div>
                  <div className="details">
                    <h3>Address</h3>
                    <p>New York, NY 10001</p>
                    <span className="note">Headquarters</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="hours-card">
              <h2>Business Hours</h2>
              <div className="hours-grid">
                <div className="hours-item">
                  <span className="day">Monday - Friday</span>
                  <span className="time">9:00 AM - 6:00 PM</span>
                </div>
                <div className="hours-item">
                  <span className="day">Saturday</span>
                  <span className="time">10:00 AM - 4:00 PM</span>
                </div>
                <div className="hours-item">
                  <span className="day">Sunday</span>
                  <span className="time">Closed</span>
                </div>
                <div className="hours-note">
                  24/7 Emergency Support Available
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <div className="form-card">
              <h2>Send Us a Message</h2>
              <form className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input type="text" id="name" placeholder="Your name" />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input type="email" id="email" placeholder="Your email" />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input type="text" id="subject" placeholder="Message subject" />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea id="message" rows="5" placeholder="Your message"></textarea>
                </div>
                <button type="submit" className="submit-button">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .contact-page {
            min-height: 100vh;
            background: linear-gradient(145deg, #1a1a1a, #000);
            color: #fff;
          }

          .hero-section {
            padding: 6rem 2rem;
            text-align: center;
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-bottom: 4px solid #ff6b35;
            position: relative;
          }

          .hero-section h1 {
            font-size: 3.5rem;
            font-weight: 800;
            margin-bottom: 1.5rem;
            text-transform: uppercase;
            letter-spacing: 2px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
          }

          .subtitle {
            font-size: 1.5rem;
            color: rgba(255,255,255,0.9);
            max-width: 800px;
            margin: 0 auto;
            font-weight: 300;
          }

          .content-section {
            max-width: 1200px;
            margin: 0 auto;
            padding: 4rem 2rem;
          }

          .contact-grid {
            display: grid;
            grid-template-columns: 1fr 1.5fr;
            gap: 3rem;
          }

          .info-card, .hours-card, .form-card {
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-radius: 12px;
            padding: 2rem;
            margin-bottom: 2rem;
            box-shadow: 0 8px 24px rgba(0,0,0,0.3);
            border: 2px solid rgba(255,255,255,0.1);
          }

          h2 {
            font-size: 2rem;
            color: #ff6b35;
            margin-bottom: 2rem;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
          }

          .info-items {
            display: flex;
            flex-direction: column;
            gap: 2rem;
          }

          .info-item {
            display: flex;
            gap: 1.5rem;
            align-items: flex-start;
          }

          .icon {
            font-size: 1.5rem;
            background: linear-gradient(145deg, #383838, #2a2a2a);
            padding: 1rem;
            border-radius: 8px;
            border: 1px solid rgba(255,255,255,0.1);
          }

          .details h3 {
            font-size: 1.2rem;
            color: #fff;
            margin-bottom: 0.5rem;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .details p {
            font-size: 1.1rem;
            color: #ff6b35;
            margin-bottom: 0.25rem;
          }

          .note {
            font-size: 0.9rem;
            color: rgba(255,255,255,0.6);
          }

          .hours-grid {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .hours-item {
            display: flex;
            justify-content: space-between;
            padding: 0.75rem;
            background: linear-gradient(145deg, #383838, #2a2a2a);
            border-radius: 6px;
            border: 1px solid rgba(255,255,255,0.1);
          }

          .day {
            font-weight: 500;
            color: #fff;
          }

          .time {
            color: #ff6b35;
          }

          .hours-note {
            text-align: center;
            margin-top: 1rem;
            padding: 1rem;
            background: rgba(255, 107, 53, 0.1);
            border-radius: 6px;
            color: #ff6b35;
            font-weight: 500;
          }

          .contact-form {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
          }

          .form-group {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }

          label {
            font-size: 1rem;
            color: #fff;
            font-weight: 500;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          input, textarea {
            padding: 1rem;
            background: linear-gradient(145deg, #222, #1a1a1a);
            border: 1px solid rgba(255,255,255,0.1);
            border-radius: 6px;
            color: #fff;
            font-size: 1rem;
            transition: all 0.3s ease;
          }

          input:focus, textarea:focus {
            outline: none;
            border-color: rgba(255, 107, 53, 0.4);
            box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.1);
          }

          .submit-button {
            background: linear-gradient(145deg, #ff6b35, #e65d2e);
            color: white;
            border: none;
            padding: 1rem 2rem;
            border-radius: 6px;
            font-size: 1.1rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
            cursor: pointer;
            transition: all 0.3s ease;
            margin-top: 1rem;
            box-shadow: 0 4px 12px rgba(255, 107, 53, 0.2);
          }

          .submit-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(255, 107, 53, 0.3);
          }

          @media (max-width: 768px) {
            .contact-grid {
              grid-template-columns: 1fr;
            }

            .hero-section h1 {
              font-size: 2.5rem;
            }

            .subtitle {
              font-size: 1.25rem;
            }

            .content-section {
              padding: 2rem 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Contact;